module.exports = __webpack_public_path__ + "static/media/arrow-red.20c16d73.svg";